import get from 'lodash/get';
import * as sectorActions from '../../action_creators/mic/mic2020_sectors_action_creators';
import SectorModel from '../../../models/mic/mic2020_sector_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchMic2020Sectors(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(sectorActions.mic2020SectorsLoading());
    return SectorModel.fetch(store)
      .then(function handleSectorData(sectorData) {
        dispatch(sectorActions.mic2020SectorsLoaded(sectorData.data, store));
      })
      .catch(function handleSectorError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(status, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in all sector actions, message: ${err.message}`
          );
        }
        dispatch(sectorActions.mic2020SectorsLoadError(err, store));
      });
  };
}
